import React from 'react'
import * as Yup from 'yup'
import SumScoredQuestionnaireFields from './SumScoredQuestionnaireFields'
import { createSumScoredQuestionnaireSchema } from './createSumScoredQuestionnaireSchema'

const ISI_QUESTIONS = [
  {
    key: 'ISI_QUESTION_1',
    label: 'Difficulty falling asleep',
  },
  {
    key: 'ISI_QUESTION_2',
    label: 'Difficulty staying asleep',
  },
  {
    key: 'ISI_QUESTION_3',
    label: 'Problems waking up too early',
  },
  {
    key: 'ISI_QUESTION_4',
    label: 'Satisfaction with current sleep pattern',
  },
  {
    key: 'ISI_QUESTION_5',
    label: 'How noticeable to others the sleep problem is',
  },
  {
    key: 'ISI_QUESTION_6',
    label: 'Worry or distress about the sleep problem',
  },
  {
    key: 'ISI_QUESTION_7',
    label: 'Interference with daily functioning',
  },
  {
    key: 'ISI_SCORE',
    label: 'Score',
  },
]

export const ISI_SCHEMA = createSumScoredQuestionnaireSchema('ISI', 7, 4)

export type ISISchema = Yup.InferType<typeof ISI_SCHEMA>

const ISIFields = () => <SumScoredQuestionnaireFields type="ISI" questions={ISI_QUESTIONS} />

export default ISIFields
